import { useCallback, useEffect, useState } from "react";
import { ModerationAdminData, fetchModerationAdminData } from "../services/moderationAdminService";

export function useModerationAdmin() {
  const [data, setData] = useState<ModerationAdminData | null>(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const refresh = useCallback(async () => {
    setIsLoading(true);
    setError("");

    try {
      setData(await fetchModerationAdminData());
    } catch {
      setData(null);
      setError("Unable to load moderation queue. Check Firebase permissions and indexes.");
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    data,
    error,
    isLoading,
    refresh
  };
}
